export default {
  variants: {
    'button-group': ({ colorScheme }) => ({
      tab: {
        flex: 1,
        borderRadius: 'lg',
        borderColor: 'gray.300',
        borderStyle: 'solid',
        bgColor: 'white',
        color: 'gray.500',
        h: '3.142rem',
        _selected: {
          color: 'white',
          bgColor: `${colorScheme}.500`,
          borderColor: `${colorScheme}.500`,
        },
        _first: {
          borderRadius: '10px 0 0 10px',
          borderTopWidth: '1px',
          borderBottomWidth: '1px',
          borderLeftWidth: '1px',
        },
        _last: {
          borderRadius: '0 10px 10px 0',
          borderTopWidth: '1px',
          borderBottomWidth: '1px',
          borderRightWidth: '1px',
        },
      },
      tablist: {
        display: 'flex',
        justifyContent: 'center',
      },
      tabpanel: {
        padding: 0,
      },
    }),
  },
};
